// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ZugewieseneRechnungBaustelle } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteZugewieseneBaustelle(): (
  rechnungsId: string,
  zugewieseneBaustellenId: string
) => Promise<ZugewieseneRechnungBaustelle> {
  const getAPI = useGetApi();
  return useCallback(
    async (rechnungsId, zugewieseneBaustellenId) =>
      (await getAPI()).rechnungen.deleteZugewieseneBaustelle({
        rechnungsId,
        zugewieseneBaustellenId,
      }),
    [getAPI]
  );
}
